module.exports = __webpack_public_path__ + "static/img/1915_phase_function_Paper_PointsHejduk_Prediction.63727e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1915_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +tOK
// module chunks = 0